'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders the error div.
 * @extends {Component}
 */
var NewErrorDivComponent = function (_React$Component) {
  _inherits(NewErrorDivComponent, _React$Component);

  function NewErrorDivComponent() {
    _classCallCheck(this, NewErrorDivComponent);

    return _possibleConstructorReturn(this, (NewErrorDivComponent.__proto__ || Object.getPrototypeOf(NewErrorDivComponent)).apply(this, arguments));
  }

  _createClass(NewErrorDivComponent, [{
    key: 'findErrors',
    value: function findErrors(result) {
      if (this.props.errors && Array.isArray(this.props.errors)) {
        for (var i = 0; i < this.props.errors.length; i++) {
          result.push(this.props.errors[i].message);
        }
      }
      return result;
    }
  }, {
    key: 'displayErrors',
    value: function displayErrors(errors) {
      if (this.props.showErrors && errors.length > 0) {
        return _react2.default.createElement(
          'div',
          { className: 'alert alert-danger', role: 'alert' },
          _react2.default.createElement(
            'p',
            { className: 'bg-danger' },
            (0, _translate.t)('Please review your application as we found the following error(s)'),
            ':'
          ),
          errors.map(function (error, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              error
            );
          })
        );
      }
      return undefined;
    }
  }, {
    key: 'render',
    value: function render() {
      var errors = this.findErrors([]);
      return _react2.default.createElement(
        'div',
        null,
        this.displayErrors(errors)
      );
    }
  }]);

  return NewErrorDivComponent;
}(_react2.default.Component);

NewErrorDivComponent.propTypes = {
  errors: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.string]),
  fields: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object]).isRequired,
  showErrors: _react2.default.PropTypes.bool.isRequired
};
exports.default = NewErrorDivComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/NewErrorDivComponent.jsx
// module id = 811
// module chunks = 0